import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import PaletteProvider from '@gojob/ui-bits/styles/PaletteProvider';

import BlockRenderer from '../../BlockRenderer';
import Image, { ImageProps } from '../../VignetteScroller/Vignette/Image';

export interface VignetteProps extends ImageProps {
  body?: any;
  title?: string;
  className?: string;
}

const Vignette: FunctionComponent<VignetteProps> = (props) => {
  const { body, title, image, className } = props;

  return (
    <Flex className={className} flex="1 0 auto" width={{ xs: '100vw', md: '100%' }} flexDirection="column">
      <PaletteProvider variant="light">
        <Image image={image}>{title}</Image>
      </PaletteProvider>

      <Flex flexDirection="column" padding={{ xs: 4, md: [4, 0] }}>
        <BlockRenderer blocks={body} />
      </Flex>
    </Flex>
  );
};

export default Vignette;
